function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 8C14 11.3144 11.3135 14 8 14C4.68652 14 2 11.3144 2 8C2 4.68749 4.68652 2 8 2C11.3135 2 14 4.68749 14 8ZM8 9.20968C7.38536 9.20968 6.8871 9.70794 6.8871 10.3226C6.8871 10.9372 7.38536 11.4355 8 11.4355C8.61464 11.4355 9.1129 10.9372 9.1129 10.3226C9.1129 9.70794 8.61464 9.20968 8 9.20968ZM6.9434 5.20937L7.12286 8.49969C7.13126 8.65366 7.25856 8.77419 7.41275 8.77419H8.58725C8.74144 8.77419 8.86874 8.65366 8.87714 8.49969L9.05661 5.20937C9.06568 5.04306 8.93327 4.90323 8.76672 4.90323H7.23326C7.06671 4.90323 6.93432 5.04306 6.9434 5.20937Z",
  fill: "#E32707"
});

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.78ae8f91.svg";
export { ForwardRef as ReactComponent };